module.exports = __webpack_public_path__ + "media/images/payment_cards/credit_cards/visa-816cd34b7366e7c0180c3ddaa8520dfa.png";